<template>
  <div class="fleet-status">
    <div class="fleet-status__item" v-for="status in fleetStatus">
      <span class="fleet-status__indicator" :style="{ backgroundColor: status.color }"></span>
      <span class="fleet-status__name">{{ status.name }}</span>
    </div>
  </div>
</template>

<script>
import fleetStatus from '../lib/constants/fleet-status'

export default {
  computed: {
    fleetStatus() {
      return fleetStatus(this)
    },
  },
}
</script>

<style scoped lang="scss">
.fleet-status {
  display: flex;
  align-items: center;
  gap: 12px;

  &__item {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__indicator {
    height: 12px;
    width: 32px;
    border-radius: 2px;
  }
}
</style>
